import React from 'react';

const ProductPhotography = () => {
  return <div>ProductPhotography</div>;
};

export default ProductPhotography;
